import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';
import { SocialLeadsAutomationService } from 'src/app/modules/shared/services/social-leads-automation/social-leads-automation.service';
import { InputValidationsService } from 'src/app/modules/shared/services/validations/input-validations.service';

@Component({
  selector: 'app-landing-lead-page',
  templateUrl: './landing-lead-page.component.html',
  styleUrls: ['./landing-lead-page.component.scss'],
})
export class LandingLeadPageComponent implements OnInit {

  code: any;
  leadForm!: FormGroup;

  showSpinner: boolean = false;
  leadFormConfig: any;

  showSuccessScreen: boolean = false;

  constructor(
    private _fb: FormBuilder,
    private _validationService: InputValidationsService,
    private _socialLeadsAutomationService: SocialLeadsAutomationService,
    private _activatedRoute: ActivatedRoute,
    private _globalService: GlobalService,
    private _responseNotificationService: ResponseNotificationService
  ) { }

  async ngOnInit() {
    this.showSpinner = true;
    this.code = this._activatedRoute.snapshot.paramMap.get("code");
    this.leadFormConfig = await this.getLeadFormConfiguration(this.code);

    this.initilizeLeadForm();
    this.showSpinner = false;
  }

  initilizeLeadForm() {
    this.leadForm = this._fb.group({
      firstName: ['', [Validators.required]],
      lastName: [''],
      phoneNumber: ['', [Validators.required]],
      email: ['', [this._validationService.emailValidator()]],
      travelServices: [[], [this._validationService.arrayNotEmptyValidator()]],
      destination: [''],
      noOfGuests: [null, []],
      startDate: [''],
      endDate: [''],
      message: ['']
    });
  }

  get today(): any {
    return new Date();
  }

  async getLeadFormConfiguration(code: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this._socialLeadsAutomationService.getLeadFormConfigurationFromCode(code).subscribe({
        next: (res) => {
          resolve(res);
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }

  clearServices() {
    this.leadForm.get("travelServices")?.setValue([]);
  }

  onSubmit() {
    if (this.leadForm.valid) {
      this.showSpinner = true;
      const serializedData = this.serializeForm(this.leadForm.value);
      this._socialLeadsAutomationService.addSociaLead(serializedData, this.code).subscribe({
        next: (res) => {
          console.log("Lead added successfully", res);
          this.initilizeLeadForm();
          this.showSpinner = false;
          this.showSuccessScreen = true;
        },
        error: (err) => {
          this.showSpinner = false;
          console.error("Error adding lead", err);
          this._responseNotificationService.showMessage("Error sending messag, please try again later", true);
        }
      });
    } else {
      this.leadForm.markAllAsTouched();
      console.error("Form is invalid");

    }
  }

  closeSuccessScreen() {
    this.showSuccessScreen = false;
  }

  serializeForm(formData: any): any {
    const serializedData = {
      ...formData,
      totalAdults: formData.noOfGuests?.noOfAdults || 0,
      totalChildrens: formData.noOfGuests?.noOfChildren || 0,
      totalInfants: formData.noOfGuests?.noOfInfants || 0,
      ownership: this.leadFormConfig.leadFormConfiguration.ownership
    }

    delete serializedData.noOfGuests;

    return serializedData;
  }

  checkFormFieldEnabled(fieldName: string): boolean {
    if (this.leadFormConfig && this.leadFormConfig.leadFormConfiguration) {
      return this.leadFormConfig.leadFormConfiguration.settings[fieldName]
    }
    return false;
  }

  getImageUrl() {
    return `url('${this.leadFormConfig.leadFormConfiguration.bannerImageUrl}')`;
  }

}